import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const EmployeeSection2Route: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const handlePopState = () => {
      const { pathname } = window.location;
      if (!pathname.startsWith('/employee-filled-section2')) {
        window.history.pushState(null, '', location.pathname + location.search);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [location]);

  const isAuthRoute = location.pathname.startsWith('/employee-filled-section2/auth/');
  const isLanding = location.pathname === '/employee-filled-section2/landing';
  const isSuccess = location.pathname === '/employee-filled-section2/success';

  if (!isAuthRoute && !isLanding && !isSuccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};
